import instance from '../utils/axios';
import multipartFileInstance from '../utils/multipartFileInstance';

class FormService {

    async getFormData(workflowTemplateId, id) {
        return await instance.get("/wf/formMobile/data?workflowTemplateId=" + workflowTemplateId + "&id=" + id);
    }

    async saveForm(data, details, id) {
        return await instance.post("/wf/formMobile/saveData", {
            data: JSON.stringify(data),
            details: JSON.stringify(details),
            workflowTemplateId: id
        })
    }

    async submitForm(id, name, version, auditorIds) {
        return await instance.post("/wf/form/vsheet/submit", {
            id: id,
            name: name,
            version: version,
            auditorIds: auditorIds
        })
    }

    async auditForm(workflowId, type, opinion, version, auditorIds) {
        var data={
            workflowId: workflowId,
            opinion: opinion,
            type: type,
            version: version,
        }
        if(auditorIds!="" && auditorIds!=undefined && auditorIds!=null){
            data.auditorIds=auditorIds;
        }
        return await instance.post("/wf/form/vsheet/Audit", data);
    }

    async saveCopy(id, ids) {
        return await instance.post("/wf/formLinkage/formCopyTo/copyTo", {
            lid: id,
            cropIds: ids
        })
    }

    async sendEmails(creatorName, ids, serialNumber, displayName) {
        return await instance.post("/oa/emailHelper/sendEmail", {
            name: creatorName,
            cropIds: ids,
            serialNumber: serialNumber,
            displayName: displayName,
            ticket: "copyTo"
        })
    }

    async uploadFile(param, config) {
        return await multipartFileInstance.post("/oa/common/attachment/uploadFile", param, config);
    }

    async deleteFile(attachmentId) {
        return await multipartFileInstance.post("/oa/common/attachment/delete", {id: attachmentId});
    }

    async getReceiveList(pageIndex) {
        return await instance.post('/wf/workflow/workflowList/getReceiveList', {
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'lastStepCompleteTime',
            sort: 'desc'
        });
    }

    async getBeforeNodeList(workflowTemplateId, formDataId, nodeId){
        return await instance.post('/wf/workflow/VSheet/getbeforeNodeList', {
            workflowTemplateId: workflowTemplateId,
            formDataId: formDataId,
            nodeId: nodeId
        });
    }

    async backWorkflow(result, workflowId, nodeId, opinion,currentNodeId){
        return await instance.post('/wf/form/vsheet/backWorkflow', {
            result: result,
            workflowId: workflowId,
            nodeId: nodeId,
            opinion: opinion,
            currentNodeId: currentNodeId
        });
    }

    async transferToOthers(staffId, nodeId, workflowId, opinion){
        return await instance.post('/wf/formLinkage/transferTo/', {
            staffId: staffId,
            nodeId: nodeId,
            workflowId: workflowId,
            opinion: opinion
        });
    }

    request(url, type, param, callback) {
        if (type === "post") {
            instance.post(url, param).then(function (res) {
                callback(res.data)
            });
        } else {
            instance.get(url).then(function (res) {
                callback(res.data)
            });
        }
    }


}

export default new FormService();